module.exports = __webpack_public_path__ + "img/744.26c8c2fa.jpg";